// Index files serve as entry points for importing and exporting functions and classes only. They should not contain any application logic or implementation details.

import global from './global';

function index() {
  global();
}

export default index;
